import React, { useState } from 'react';
import PropTypes from 'prop-types';

function Switcher({ onChange }) {
	const [isChecked, setIsChecked] = useState(false);

	const handleCheckboxChange = () => {
		setIsChecked(!isChecked);
		onChange();
	};

	return (
		<label
			style={{
				display: 'flex',
				cursor: 'pointer',
				alignItems: 'center',
			}}
		>
			<div style={{ position: 'relative' }}>
				<input
					type="checkbox"
					checked={isChecked}
					onChange={handleCheckboxChange}
					style={{ display: 'none' }}
				/>
				{/* Track */}
				<div
					style={{
						width: '36px',
						height: '18px',
						borderRadius: '10px',
						border: '1px solid',
						borderColor: isChecked ? '#000000' : '#BFCEFF',
						backgroundColor: isChecked ? '#000000' : '#EAEEFB',
						transition: 'background-color 0.3s, border-color 0.3s',
					}}
				/>
				{/* Knob */}
				<div
					style={{
						position: 'absolute',
						top: '1px',
						left: isChecked ? '22px' : '1px',
						width: '14px',
						height: '14px',
						borderRadius: '50%',
						backgroundColor: '#ffffff',
						boxShadow: '0 2px 4px rgb(0, 0, 0)',
						transition: 'left 0.3s',
					}}
				/>
			</div>
		</label>
	);
}

Switcher.propTypes = {
	onChange: PropTypes.func.isRequired,
};

export default Switcher;
